//Custom components

import BarChart from '@/components/UI/Charts/BarChart';
import { CurrencyFormatDisplay } from '@/components/UI/NumberFormatDisplay/CurrencyFormatDisplay';

//Services
import { useDashboardData } from '@/hooks/ReactQueryHooks/useDashboardQuery';

//Assets and Miscellaneous
import type { DashboardType } from '@/types/Analytics.ts';
import Card from '../../UI/Card/index.tsx';
import { Widget } from '../constants';
import WidgetLayout from '../WidgetLayout';

interface SourcesWidgetDataResponse {
  source_name: string;
  total_amount: number;
}

export default function TotalProjectSourcesWidget({ dashboard }: { dashboard: DashboardType }) {
  const fetchSourcesWidgetData = useDashboardData({
    dashboard,
    widget: Widget.PROJECTS_BY_SOURCES,
  });

  const sourcesWidgetData = fetchSourcesWidgetData?.data?.data;

  const sourcesLabels: string[] = sourcesWidgetData?.map((data: SourcesWidgetDataResponse) => data?.source_name);

  const sourcesDatasets: number[] = sourcesWidgetData?.map((data: SourcesWidgetDataResponse) => data?.total_amount);

  const totalSources: number = sourcesDatasets?.reduce((acc: number, next: number) => acc + next, 0);

  return (
    <WidgetLayout dashboard={dashboard} widget={Widget.PROJECTS_BY_SOURCES} actionsBtnLocation='hidden'>
      <section className='flex gap-8 h-full'>
        <Card title='Project Sources' error={fetchSourcesWidgetData.isError}>
          {fetchSourcesWidgetData && (
            <>
              <div className='flex flex-row justify-between items-center px-8 py-4'>
                <span className='flex flex-col'>
                  <p className='text-gray-400 text-sm'>Total Sources</p>
                  <p className='text-black-800 font-bold text-lg'>
                    <CurrencyFormatDisplay value={totalSources} prefix='$' />
                  </p>
                </span>
              </div>
              <div className='p-5 max-w-full'>
                <BarChart dataLabels={sourcesLabels} colors={false} datasets={sourcesDatasets} />
              </div>
            </>
          )}
        </Card>
      </section>
    </WidgetLayout>
  );
}
